import { render, staticRenderFns } from "./PrivacyTab.vue?vue&type=template&id=abcd0722&scoped=true&"
import script from "./PrivacyTab.vue?vue&type=script&lang=js&"
export * from "./PrivacyTab.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyTab.vue?vue&type=style&index=0&id=abcd0722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcd0722",
  null
  
)

export default component.exports